import type { StaticImageData } from "next/image";

export enum WorkMode {
    REMOTE = "Remote",
    ON_SITE = "On-Site",
    HYBRID = "Hybrid",
}

export interface CompanyRole {
    title: string;
    started_date: string;
    ended_date?: string;
}

export default interface Company {
    id: string;
    name: string;
    description: string;
    roles: CompanyRole[];
    started_date: string;
    ended_date?: string;
    achievements: string[];
    logo: StaticImageData;
    work_mode: WorkMode;
    endorsement?: {
        quote: string;
        author: string;
        title: string;
    };
}
